module.exports = __webpack_public_path__ + "img/success-icons.4dadea5d.svg";